var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prewrap"},[_c('ReNoteJsonItem',{attrs:{"items":_vm.rows}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }